import { get } from "sites-common/utils/lodash";
import {
  queryAdmins,
  adminsConfig,
  postprocessAdmins,
  adminsSelectors,
  validateAdmins,
} from "../../common1/firebase-selectors/admins";
import RenderColumns from "./renderItemCard";
import { adminsCareAppUrl, homeCareAppUrl } from "../../care-app/urls";
import { saveSettings } from "../../common1/firebase-selectors/settings";

const Config = (i_am_admin = false) => {
  const pSelectors = adminsSelectors();

  return {
    primaryKey: adminsConfig.primaryKey,

    disableEditPrimaryKey: true,

    initialQueries: [queryAdmins()],

    homeUrl: adminsCareAppUrl,
    backUrl: homeCareAppUrl,

    sessionKey: "careapp.admins",
    noItemMsg: "No Admins Loaded",
    mainTitle: "Admins",
    mainTitleIcon: "Sunny",

    pageOptions: {
      "All Admins": {
        optionsSelector: (/* state */) => [{ key: "all", text: "All Admins" }],
        pageSelector: pSelectors.ordered,
      },
    },

    singleItemSelector: pSelectors.id,
    singleItemDispatcher: null,

    collection: adminsConfig.collection,
    postprocess: postprocessAdmins,
    validate: validateAdmins,
    formFields: adminsConfig.fields,
    formDefaults: adminsConfig.defaults,

    postSave: ({ dbStore }) => {
      dbStore.getSnapshot(adminsConfig.collection).then((snapshot) => {
        const admins = {};
        snapshot.forEach((doc) => {
          admins[doc.id.toLowerCase()] = true;
        });

        saveSettings(dbStore, { admins });
      });
    },

    editBtnText: "View / Edit Details",
    newBtnText: i_am_admin ? "New" : null,

    panelForNewItem: true,
    panelForEditItem: true,

    renderItemCard: null,
    colDefns: RenderColumns(adminsConfig.primaryKey),
    showTableHeader: true,
    displayAsTable: true,
    tableEditButtonProps: i_am_admin ? { text: "Edit" } : null,

    filterProps: {
      placeholder: "Name / City / Email / State",
      searchFunction: (r) =>
        `${r.name} ${r.city} ${r.email} ${r.country} ${r.state}`,
      filterMenuItems: [
        {
          key: "name",
          text: "Name (Ascending)",
          f: (a, b) => a.name.toLowerCase() > b.name.toLowerCase(),
        },
        {
          key: "city",
          text: "City (Ascending)",
          f: (a, b) =>
            get(a, "city", "").toLowerCase() > get(b, "city", "").toLowerCase(),
        },
        {
          key: "city_d",
          text: "City (Descending)",
          f: (a, b) =>
            get(a, "city", "").toLowerCase() <=
            get(b, "city", "").toLowerCase(),
        },
        {
          key: "email",
          text: "Email (Asscending)",
          f: (a, b) =>
            get(a, "email", "").toLowerCase() >
            get(b, "email", "").toLowerCase(),
        },
      ],
    },
  };
};
export default Config;
